import React from 'react';
import SampleMessage from 'components/SampleMessage';

const SupporterPage: React.FC = () => {
  return (
    <SampleMessage api_path="supporter/welcome" />
  );
};

export default SupporterPage;
